// extracted by mini-css-extract-plugin
export var hamburger = "header-module--hamburger--2fd23";
export var header = "header-module--header--a840d";
export var logo = "header-module--logo--6cb3b";
export var logoImg = "header-module--logoImg--85e61";
export var logoText = "header-module--logoText--a09e4";
export var wrapper = "header-module--wrapper--72e96";